import React, { createContext, useState } from "react";

export const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [promptEndSession, setPromptEndSession] = useState(false);
  const [promptLogout, setPromptLogout] = useState(false);

  return (
    <NavigationContext.Provider
      value={{ pendingNavigation, setPendingNavigation, promptEndSession, setPromptEndSession, promptLogout,
        setPromptLogout }}
    >
      {children}
    </NavigationContext.Provider>
  );
};